import React from 'react'
import { Dashboard } from '../components/dashboard'

export const HomePage = () => {
    return (
        <div>
            <Dashboard/>
        </div>
    )
}
